import React from "react";
import {
  safe,
  asList,
  formatAddress,
  formatUKPhone,
  initialsFrom,
  cssColor,
  fmtMaybeDate,
  fmtMaybeMonthYear,
  statusColor,
  QUAL_GROUPS,
  pickTruthy,
} from "../../Utils/AdviserFormatters";
import { Chip, PostCard, Row } from "../HelperFunctions/HelperFunctions";

const ProfessionalQualifications = ({
    details,
    


}) => {
    return (
      <div className="smFeed">
        <PostCard title="Professional qualifications">
          {!details?.professionalQualifications ? (
            <div className="Content-Small muted">-</div>
          ) : (
            <>
              {QUAL_GROUPS.map((g) => {
                const q = details.professionalQualifications;

                // Only show the "Yes" ones (cleaner)
                const yesKeys = pickTruthy(q, g.keys);

                return (
                  <div key={g.title} style={{ marginBottom: 14 }}>
                    <div
                      className="Content-SemiBold"
                      style={{ marginBottom: 6 }}
                    >
                      {g.title}
                    </div>

                    {yesKeys.length ? (
                      <div className="smChips">
                        {yesKeys.map((k) => (
                          <Chip key={k} className="smChipTrading">
                            {k.replace(/_/g, " ")}
                          </Chip>
                        ))}
                      </div>
                    ) : (
                      <div className="Content-Small muted">None selected</div>
                    )}
                  </div>
                );
              })}

              {/* Free-text higher level qualifications */}
              <div style={{ marginTop: 10 }}>
                <div className="Content-SemiBold" style={{ marginBottom: 6 }}>
                  Higher level qualifications
                </div>
                <div className="smGrid2">
                  <Row
                    label="Qualification 1"
                    value={
                      details.professionalQualifications?.Qualification1 || "-"
                    }
                  />
                  <Row
                    label="Qualification 2"
                    value={
                      details.professionalQualifications?.Qualification2 || "-"
                    }
                  />
                  <Row
                    label="Qualification 3"
                    value={
                      details.professionalQualifications?.Qualification3 || "-"
                    }
                  />
                </div>
              </div>
            </>
          )}
        </PostCard>
      </div>
    );
};

export default ProfessionalQualifications;
